import React from 'react'
import AsyncComponent from './async.component'
import { routes } from '../../constants/routes.constants'
import { connect } from 'react-redux'
import { UserService } from '../../services/user.service'
import { Route, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'

export class PrivateRouteComponent extends React.Component {
	constructor(props) {
		super(props)
	}

	shouldComponentUpdate(nextProps, nextState) {
		const { module: Module } = this.props
		return Module !== nextProps.module
	}

	componentWillMount() {
		const { user, history } = this.props

		if (!user) {
			history.push(routes.ENTRAR)
			return
		}

		if (!user.roles) {
			history.push('/')
		}
	}

	render() {
		return renderContent.call(this)
	}
}

function renderContent() {
	const {
		module: Module,
		layout: Layout,
		roles,
		noPadding,
		...rest
	} = this.props
	return (
		<Route
			{...rest}
			component={() =>
				Layout ? (
					<Layout noPadding={noPadding}>
						<AsyncComponent moduleProvider={Module} />
					</Layout>
				) : (
					<AsyncComponent moduleProvider={Module} />
				)
			}
		/>
	)
}

const mapStoreToProps = (store) => {
	const { site, user } = store
	return {
		...site,
		user: user,
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
		},
		dispatch
	)

const PrivateRoute = withRouter(
	connect(mapStoreToProps, mapDispatchToProps)(PrivateRouteComponent)
)

export { PrivateRoute }
